/**
 * 羽归阁博客系统 - 主应用组件
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { PostStatsProvider } from '@/context/PostStatsContext';

// 页面组件
const Home = React.lazy(() => import('@/pages/Home/index'));
const Post = React.lazy(() => import('@/pages/Post/index'));
const Category = React.lazy(() => import('@/pages/Category'));
const Tag = React.lazy(() => import('@/pages/Tag'));
const Tags = React.lazy(() => import('@/pages/Tags'));
const Archive = React.lazy(() => import('@/pages/Archive'));
const Timeline = React.lazy(() => import('@/pages/Timeline'));
const About = React.lazy(() => import('@/pages/About'));
const Contact = React.lazy(() => import('@/pages/Contact'));
const Links = React.lazy(() => import('@/pages/Links'));
const Stats = React.lazy(() => import('@/pages/Stats'));
const Lab = React.lazy(() => import('@/pages/Lab'));
const LabDice = React.lazy(() => import('@/pages/Lab/Dice'));

// 加载组件
const LoadingSpinner: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
  </div>
);

// 404页面
const NotFound: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
      <p className="text-gray-600 dark:text-gray-400">页面未找到</p>
    </div>
  </div>
);

const App: React.FC = () => {
  return (
    <PostStatsProvider>
      <React.Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="post/:slug" element={<Post />} />
            <Route path="category/:slug" element={<Category />} />
            <Route path="tag/:slug" element={<Tag />} />
            <Route path="tags" element={<Tags />} />
            <Route path="archive" element={<Archive />} />
            <Route path="timeline" element={<Timeline />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="links" element={<Links />} />
            <Route path="stats" element={<Stats />} />
            <Route path="lab" element={<Lab />} />
            <Route path="lab/dice" element={<LabDice />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Suspense>
    </PostStatsProvider>
  );
};

export default App;
